import { render, staticRenderFns } from "./conf_column.vue?vue&type=template&id=b7088468&"
import script from "./conf_column.vue?vue&type=script&lang=js&"
export * from "./conf_column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports